import React, { useEffect } from 'react';
import './Get5TPCModal.css';

interface Get5TPCModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const Get5TPCModal: React.FC<Get5TPCModalProps> = ({ isOpen, onClose }) => {
  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="get5tpc-modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }}>
      <div className="get5tpc-modal-content">
        <button
          className="close-get5tpc-modal-btn"
          onClick={onClose}
        >
          ×
        </button>

        <div className="modal-body">
          <div className="get5tpc-step">
            <h2 className="step-title">Refer a friend</h2>
            <p className="step-content">
              Earn 5 $TPC by referring a friend! Share your referral code (which is on your parlay slip) and when they place their first parlay, you'll receive 5 $TPC.
            </p>
          </div>
        </div>

        <div className="step-navigation">
          <button className="got-it-btn" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default Get5TPCModal;
